/**
* this is the dashboard loader component for the dashboard items
*
* Created by Tom on 13/06/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'

// style import
import './style.scss'

class DashboardLoader extends Component {

    renderSwitch() {
        const { type } = this.props

        // return the loader layput for the requested type
        switch (type) {
            // investement loader
            case 'investment':
                return (<div className="dashboard-loader__investment">

                    {/* TODO: create loader - for the time being use news loader */}
                    <div className="dashboard-loader__news__left">
                        <div className="animated-bg dashboard-loader__news__top"></div>
                        <div className="animated-bg dashboard-loader__news__small"></div>
                        <div className="animated-bg dashboard-loader__news__medium"></div>
                        <div className="animated-bg dashboard-loader__news__long"></div>
                        <div className="animated-bg dashboard-loader__news__small"></div>
                        <div className="animated-bg dashboard-loader__news__medium"></div>
                        <div className="animated-bg dashboard-loader__news__long"></div>
                        <div className="dashboard-loader__news__mobile">
                            <div className="animated-bg dashboard-loader__news__small"></div>
                            <div className="animated-bg dashboard-loader__news__medium"></div>
                            <div className="animated-bg dashboard-loader__news__long"></div>
                        </div>
                    </div>
                    <div className="animated-bg dashboard-loader__news__right"></div>

                </div>)
            // transaction loader
            case 'transaction':
                return (<div className="dashboard-loader__transaction">

                    {/* TODO: create loader - for the time being use news loader */}
                    <div className="dashboard-loader__news__left">
                        <div className="animated-bg dashboard-loader__news__top"></div>
                        <div className="animated-bg dashboard-loader__news__small"></div>
                        <div className="animated-bg dashboard-loader__news__medium"></div>
                        <div className="animated-bg dashboard-loader__news__long"></div>
                        <div className="animated-bg dashboard-loader__news__small"></div>
                        <div className="animated-bg dashboard-loader__news__medium"></div>
                        <div className="animated-bg dashboard-loader__news__long"></div>
                        <div className="dashboard-loader__news__mobile">
                            <div className="animated-bg dashboard-loader__news__small"></div>
                            <div className="animated-bg dashboard-loader__news__medium"></div>
                            <div className="animated-bg dashboard-loader__news__long"></div>
                        </div>
                    </div>
                    <div className="animated-bg dashboard-loader__news__right"></div>

                </div>)
            // news loader
            case 'news':
                return (<div className="dashboard-loader__news">

                    <div className="dashboard-loader__news__left">
                        <div className="animated-bg dashboard-loader__news__top"></div>
                        <div className="animated-bg dashboard-loader__news__small"></div>
                        <div className="animated-bg dashboard-loader__news__medium"></div>
                        <div className="animated-bg dashboard-loader__news__long"></div>
                        <div className="animated-bg dashboard-loader__news__small"></div>
                        <div className="animated-bg dashboard-loader__news__medium"></div>
                        <div className="animated-bg dashboard-loader__news__long"></div>
                        <div className="dashboard-loader__news__mobile">
                            <div className="animated-bg dashboard-loader__news__small"></div>
                            <div className="animated-bg dashboard-loader__news__medium"></div>
                            <div className="animated-bg dashboard-loader__news__long"></div>
                        </div>
                    </div>
                    <div className="animated-bg dashboard-loader__news__right"></div>

                </div>)
            // portfolio loader
            default:
                return (<div className="dashboard-loader__portfolio">

                    {/* TODO: create loader - for the time being use news loader */}
                    <div className="dashboard-loader__news__left">
                        <div className="animated-bg dashboard-loader__news__top"></div>
                        <div className="animated-bg dashboard-loader__news__small"></div>
                        <div className="animated-bg dashboard-loader__news__medium"></div>
                        <div className="animated-bg dashboard-loader__news__long"></div>
                        <div className="animated-bg dashboard-loader__news__small"></div>
                        <div className="animated-bg dashboard-loader__news__medium"></div>
                        <div className="animated-bg dashboard-loader__news__long"></div>
                        <div className="dashboard-loader__news__mobile">
                            <div className="animated-bg dashboard-loader__news__small"></div>
                            <div className="animated-bg dashboard-loader__news__medium"></div>
                            <div className="animated-bg dashboard-loader__news__long"></div>
                        </div>
                    </div>
                    <div className="animated-bg dashboard-loader__news__right"></div>
                    
                </div>)
        }
    }

    render() {
        return (
            <div className="dashboard-loader">
                {::this.renderSwitch()}
            </div>
        )
    }
}


// define the prop types
DashboardLoader.propTypes = {
    type: PropTypes.string
}

export default DashboardLoader



// WEBPACK FOOTER //
// ./src/components/DashboardLoader/index.js